import React, { forwardRef } from 'react';
const PopoverFooter = (StyledPopoverFooter) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledPopoverFooter ref={ref} {...props}>
        {children}
      </StyledPopoverFooter>);
});
export default PopoverFooter;
